import { render, staticRenderFns } from "./new.content-sections.page.vue?vue&type=template&id=7ae66998&scoped=true&"
import script from "./new.content-sections.page.vue?vue&type=script&lang=js&"
export * from "./new.content-sections.page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ae66998",
  null
  
)

export default component.exports